module.exports = __webpack_public_path__ + "static/img/broker3.f9365e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broker3.png
// module id = cJp5
// module chunks = 0